import { Component } from '@angular/core';

@Component({
  selector: 'app-social-dinner25',
  templateUrl: './social-dinner25.component.html',
  styleUrl: './social-dinner25.component.css'
})
export class SocialDinner25Component {

}
